import {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import {useUserProfileContext} from '../../context/UserProfileContext'
import {ProfileMemberHeader} from './components/ProfileMemberHeader'
import {ProfileMemberTabs} from './components/ProfileMemberTabs'
import {ProfileMemberMeta} from './components/ProfileMemberMeta'
import {ProfileMemberInfo} from './components/ProfileMemberInfo'
import {ProfileMemberImage} from './components/ProfileMemberImage'
import {ProfileMemberTabsSection} from './components/ProfileMemberTabsSection'
import { MyTeamWrapper } from '../myTeam/MyTeamWrapper'
import MemberExpertiseTab from './components/MemberExpertiseTab'
import { MyExperiencesWrapper } from './components/experiences/ExperienceWrapper'
import { LoaderOverlay } from '../../hooks/loader/LoaderOverlay'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { UserModel } from '../../modules/auth/models/UserModel'
import { CreditsAndPaymentsWrapper } from './components/creditsAndPayments/CreditsAndPaymentsWrapper'
import { SupportTicketWrapper } from './components/SupportTicketWrapper'
import { ProfileMemberCommunity } from './components/community/ProfileMemberCommunity'
import { IntroductionWrapper } from './components/introduction/IntroductionWrapper'

export function ProfileMemberPage() {
  const history = useHistory()
  const [activeTab, setActiveTab] = useState('general')
  const {data, loading, setSearchParams} = useUserProfileContext()
  const [isLoading, setIsLoading] = useState(true);
  const [userId, setUserId] = useState(0);
  const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  const {
    firstName,
    surname,
    aliasTitle,
    bioPresentation,
    city,
    languages = [],
    profilePicture,
    picFooter,
    subscription,
    expertise = [],
    introduction = [],
    socialMediaProfiles = [],
    assignedManager,
    introductionHeadline,
    guidingPrinciple,
    isFoundingMember,
  } = data ?? {}

  useEffect(() => {
    if(data?.user && data?.user != user.id){
      setUserId(Number(data?.user || 0))
      setIsLoading(false)
    }
  },[data])

  useEffect(() => {
    return () => {
      const nextPath = history.location.pathname
      const keepUserRoutes = [
        '/biography/overview',
        '/profile-member',
        '/admin/overview/professional',
        '/admin/overview/personal',
        '/admin/overview/confidential',
        '/admin/overview/profile',
        '/recognition',
        '/expertise',
        '/my-team',
        '/experience/',
      ]

      const shouldKeepUser = keepUserRoutes.some((route) => nextPath.includes(route))
      if (!shouldKeepUser) {
        setSearchParams({userSelected: ''})
      }
    }
  }, [setSearchParams, history])

  return userId && (
    <div className='nb-pm-page'>
      <ProfileMemberHeader
        firstName={firstName ?? ''}
        surname={surname ?? ''}
        onClose={() => history.replace('/manage-members')}
      />
      <ProfileMemberTabs activeTab={activeTab} onTabChange={setActiveTab} />
      <ProfileMemberMeta 
        userId={userId} 
        username={`${firstName} ${surname}`.trim()}
        assignedAdmin={`${assignedManager?.firstName ?? 'N/A'} ${assignedManager?.lastName ?? ''}`} 
        plan={subscription?.plan?.title || ''} 
        styles={{ marginTop: '25px' }}
      />
      
      {activeTab == 'general' && (<div className='nb-pm-content'>
        <div className='nb-pm-content__left'>
          <ProfileMemberInfo
            userId={userId}
            user={'user'}
            expertise={expertise}
            firstName={firstName ?? ''}
            surname={surname ?? ''}
            aliasTitle={aliasTitle ?? ''}
            bioPresentation={introductionHeadline ?? ''}
            city={city ?? ''}
            languages={languages!}
            introduction={introduction}
            socialMediaProfiles={socialMediaProfiles}
            subscription={subscription}
            isFoundingMember={isFoundingMember}
          />
        </div>
        <ProfileMemberImage profilePicture={profilePicture ?? ''} id={userId} picFooter={guidingPrinciple ?? ''} loading={loading} />
      </div>)}
      {activeTab == 'general' && (<ProfileMemberTabsSection />)}
      {activeTab == 'team' && (<MyTeamWrapper userTeamId={userId} firstName={data?.firstName + ''} lastName={data?.lastName + ''} showHeader={false} />)}
      {activeTab == 'experiences' && (<MyExperiencesWrapper userId={userId} />)}
      {activeTab == 'introductions' && (<IntroductionWrapper userId={userId} />)}
      {activeTab == 'expertise' && (<MemberExpertiseTab userId={userId} />)}
      {activeTab == 'community' && 
        <ProfileMemberCommunity userId={userId} assignedManager={assignedManager ?? undefined} subscription={subscription ?? undefined} />
      }
      {activeTab == 'credits' && (<CreditsAndPaymentsWrapper userId={userId} />)}
      {activeTab == 'support' && (<SupportTicketWrapper userId={userId} />)}
      <LoaderOverlay visible={isLoading} message={'Loading...'} />
    </div>
  )
}